import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';


const initialState = {
    show: false,
    name:'',
    step:0
}

const modalShow =  (state,action)=>{
    return updateObject(state,{
        show:true,
        name:action.name,
        step:0
    });
}
const modalHide =  (state,action)=>{
    return updateObject(state,{
        show:false,
        name:'',
        step:0
    });
    
}

const modalNext =  (state,action)=>{
    return updateObject(state,{
        step:state.step +1
    });
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.MODAL_SHOW: return modalShow(state, action);
        case actionTypes.MODAL_HIDE: return modalHide(state, action);
        case actionTypes.MODAL_NEXT: return modalNext(state, action);
        default:return state;
    }
};



export default reducer;